export default __webpack_public_path__ + "locales/sr-Latn-RS/ArchiveDialog.json?hash=b4488d912c9d471133a793166e4fe011";